<script setup lang="ts">
import logoUrl from '@/assets/supertrade-logo.png';
import markUrl from '@/assets/supertrade-mark.png';

// super_trade: full logo (with the SUPERTRADE wordmark) for large sizes, the emblem only for small
// sizes where the wordmark would be unreadable.
const props = withDefaults(defineProps<{ variant?: 'mark' | 'full' }>(), { variant: 'mark' });
</script>

<template>
  <img
    :src="props.variant === 'full' ? logoUrl : markUrl"
    alt="SuperTrade logo"
    title="SuperTrade"
    class="mx-auto object-contain transition-all duration-300"
  />
</template>
